(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-trust-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ff-trust-footer')) {
    customElements.define('ff-trust-footer', class extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia('(min-width: 750px)');
        this.details = Array.from(this.querySelectorAll('.ff-footer__details'));
        this.sync = () => {
          this.details.forEach(detail => {
            detail.open = this.media.matches || this.dataset.editor === 'true';
            const summary = detail.querySelector('summary');
            if (this.media.matches) {
              summary.setAttribute('tabindex', '-1');
              summary.setAttribute('aria-disabled', 'true');
            } else {
              summary.removeAttribute('tabindex');
              summary.removeAttribute('aria-disabled');
            }
          });
        };
        this.onClick = event => {
          if (this.media.matches && event.target.closest('.ff-footer__summary')) event.preventDefault();
        };
        this.onSelect = event => {
          const column = event.target.closest('.ff-footer__column');
          if (column && this.contains(column)) column.querySelector('details').open = true;
        };
        this.media.addEventListener('change', this.sync);
        this.addEventListener('click', this.onClick);
        document.addEventListener('shopify:block:select', this.onSelect);
        this.sync();
      }
      disconnectedCallback() {
        this.media.removeEventListener('change', this.sync);
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('shopify:block:select', this.onSelect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
